import { createActions } from 'utils/actions';

/**
 * Redux actions to set idle state.
 *
 * @type {Object}
 */
export const setIdleStatus = createActions('ui', 'SET_IDLE_STATUS');
